'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _striptags = _interopRequireDefault(require("striptags"));
var _fa = require("react-icons/fa");
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _utilities = require("Shared/utilities");
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  app,
  qwest
} = window;
class FrontNewsPage extends _react.Component {
  state = {
    loading: false,
    news: [],
    news_count: 0,
    searched_title: '',
    page: 0,
    rows_per_page: 25,
    order: 'desc',
    order_by: 'created_at',
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchNews({});
  }
  fetchNews = ({
    page,
    order,
    order_by,
    searched_title
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    page = typeof page === 'undefined' ? state.page : page;
    order = order || state.order;
    order_by = order_by || state.order_by;
    component.setState({
      loading: true
    });
    qwest.post('/news/get-all', {
      limit: state.rows_per_page,
      skip: state.rows_per_page * page,
      with_count: true,
      searched_title: searched_title || state.searched_title,
      order: order,
      order_by: order_by
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        news: (response.news || []).filter(news => (0, _utilities.isTrue)(news.visibility)).map(function (news) {
          news.description = (0, _striptags.default)(news.description || '');
          return news;
        }),
        news_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      searched_title: value
    });
    if (component.timeout) window.clearTimeout(component.timeout);
    component.timeout = window.setTimeout(function () {
      component.timeout = undefined;
      component.fetchNews({
        searched_title: value
      });
    }, 800);
  };
  handleChangePage = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page: page
    });
    component.fetchNews({
      page: page
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const news = (state.news || []).map(function (news) {
      return /*#__PURE__*/_react.default.createElement(_Link.default, {
        className: "c-blog-item c-blog-item--news",
        key: news.id,
        href: (0, _Routes.URL)('FrontNewsDetails').replace(':slug', news.slug)
      }, news.images?.[0]?.url ? /*#__PURE__*/_react.default.createElement("div", {
        className: "c-blog-item__img-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_Image.default, {
        className: "c-blog-item__image",
        src: news.images[0].url,
        alt: news.title
      })) : undefined, /*#__PURE__*/_react.default.createElement("h2", {
        className: "c-blog-item__title"
      }, news.title), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-blog-item__txt"
      }, (0, _utilities.getTruncatedText)(news.description, 120)), /*#__PURE__*/_react.default.createElement("span", {
        className: "c-blog-item__link"
      }, /*#__PURE__*/_react.default.createElement(_fa.FaLongArrowAltRight, {
        className: "c-blog-item__link-icon"
      }), "Voir l'actualit\xE9"));
    });
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Actualit\xE9s | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title u-text-center u-margin-bottom-0"
    }, "Actualit\xE9s"), /*#__PURE__*/_react.default.createElement("p", {
      className: "u-text-center u-bold u-margin-top-0"
    }, "D\xE9couvrez tous nos derni\xE8res communications"), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleSearchChange,
      className: "c-blog-search",
      name: "searched_title",
      label: "Rechercher",
      status: state.status_messages,
      value: state.searched_title
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-blog-list"
    }, news)));
    return output;
  }
}
exports.default = FrontNewsPage;
